import IListFilter from "@/models/IListFilter";
import {isEmpty} from "@/helpers/functions_asi";

export default class OrderListFilter implements IListFilter {

	public includeIds: string[] = [];
	public fulltext: string | null = null;

	public name: string | null = null;
	public companyName: string | null = null;
	public dateFrom: string | null = null;
	public dateTo: string | null = null;

	clear(): void {
		this.fulltext = null;
		this.name = null;
		this.companyName = null;
		this.dateFrom = null;
		this.dateTo = null;
	}

	hasFilter(): boolean {
		return !isEmpty(this.fulltext) || !isEmpty(this.name) || !isEmpty(this.companyName)
			|| !isEmpty(this.dateFrom) || !isEmpty(this.dateTo);
	}

}
